// extracted by mini-css-extract-plugin
module.exports = {"img":"Timeout_img__1F1YM","title":"Timeout_title__2EyRz","subtitle":"Timeout_subtitle__mG_Dw","subsubtitle":"Timeout_subsubtitle__30Jpq","button":"Timeout_button__F3F8c"};